import { createStyles } from '@material-ui/core/styles';

import fonts from '../fonts';

export default createStyles({
  root: {
    '&.MuiFormControlLabel-root .MuiFormControlLabel-label': {
      fontSize: fonts.sizes.small,
    },
  },
});
